import { useShallow } from "zustand/react/shallow";
import { useProfileStore } from "../features/initialRegistration/profileStore";
import { getCountryConfig } from "../config/countries/countryUtil";

export const useIsGsgHidden = (): boolean => {
  const country = useProfileStore(useShallow((state) => state.country));
  const countryConfig = getCountryConfig(country);
  return !!countryConfig?.missingGsgStep;
};
